import { Flex } from '@aloft/toolkit-sui';

import { PopoverOptionRow } from './PopoverOptionRow.tsx';
import { SourceOption } from './types.ts';

type PopoverOptionsListProps = {
  options: SourceOption[];
  onSelect: (option: SourceOption) => void;
};

export const PopoverOptionsList = ({ options, onSelect }: PopoverOptionsListProps) => (
  <Flex flexDirection="column" gap="1px" maxHeight="25vh" overflowY="auto">
    {options.map((option) => (
      <PopoverOptionRow
        key={`${option.source}-${option.value ?? ''}`}
        value={option.value}
        source={option.source}
        onClick={() => onSelect(option)}
      />
    ))}
  </Flex>
);
